


<template>
<div class="equal-pay-panel" ref="container">
  <header class="header">
    <span>Diversity and Equal Pay</span>
    <svg viewBox="0 0 4 20" class="editIcon" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>tileEdit</title><circle cx="2" cy="2" r="2" fill="#898A8C"></circle><circle cx="2" cy="10" r="2" fill="#898A8C"></circle><circle cx="2" cy="18" r="2" fill="#898A8C"></circle></svg>
  </header>
  <div class="details">
    <p>Average Annual Wage</p>
    <p class="legend"><span class="blue-dot"></span>My Company</p>
    <p class="amount">$77,408</p>
  </div>
  <div style="position:relative;">
    <div class="chart-container">
      <svg class="chartSVG" width="100%" height="100%" viewBox="0 0 260 260" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"><defs><clipPath id="kdef28"><path d="M70 31 L 243.5 31 243.5 237 70 237Z" stroke="#000" stroke-linejoin="miter" fill="none"></path></clipPath></defs><g><path d="M0 0 L 260 0 260 256 0 256Z" stroke="none" fill="#fff"></path><path d="M70 31 L 243.5 31 243.5 237 70 237Z" stroke="none" fill="#fff" fill-opacity="0"></path><g><g></g><g></g><g><g><g><path d="M70.5 31.5 L 70.5 237.5" stroke="#d8d8d8" stroke-width="1" fill="none"></path></g></g></g><g clip-path="url(#kdef28)"><g><g><g><path @mouseover="onCircleOver" @mouseout="onCircleOut" data-index="0" d="M-300000 43 L 228 43 228 60 -300000 60Z" stroke="#4b6caa" stroke-width="0" stroke-opacity="1" fill="#4b6caa" fill-opacity="1"></path></g></g><g><g><path @mouseover="onCircleOver" @mouseout="onCircleOut" data-index="1" d="M-300000 85 L 133 85 133 101 -300000 101Z" stroke="#4b6caa" stroke-width="0" stroke-opacity="1" fill="#4b6caa" fill-opacity="1"></path></g></g><g><g><path @mouseover="onCircleOver" @mouseout="onCircleOut" data-index="2" d="M-300000 126 L 126 126 126 142 -300000 142Z" stroke="#4b6caa" stroke-width="0" stroke-opacity="1" fill="#4b6caa" fill-opacity="1"></path></g></g><g><g><path @mouseover="onCircleOver" @mouseout="onCircleOut" data-index="3" d="M-300000 167 L 113 167 113 183 -300000 183Z" stroke="#4b6caa" stroke-width="0" stroke-opacity="1" fill="#4b6caa" fill-opacity="1"></path></g></g><g><g><path @mouseover="onCircleOver" @mouseout="onCircleOut" data-index="4" d="M-300000 208 L 70 208 70 225 -300000 225Z" stroke="#4b6caa" stroke-width="0" stroke-opacity="1" fill="#4b6caa" fill-opacity="1"></path></g></g></g></g><g><text style="font:12px sans-serif;white-space:pre;" x="28" y="60.6" stroke="none" fill="#707070" fill-opacity="1">2 West</text></g><g><text style="font:12px sans-serif;white-space:pre;" x="41" y="101.80000000000001" stroke="none" fill="#707070" fill-opacity="1">East</text></g><g><text style="font:12px sans-serif;white-space:pre;" x="5" y="143" stroke="none" fill="#707070" fill-opacity="1">101 Safe…</text></g><g><text style="font:12px sans-serif;white-space:pre;" x="1" y="184.2" stroke="none" fill="#707070" fill-opacity="1">70000 Ce…</text></g><g><text style="font:12px sans-serif;white-space:pre;" x="0" y="225.4" stroke="none" fill="#707070" fill-opacity="1">TMS Payroll</text></g><g><g><path d="M70.5 237.5 L 244.5 237.5" stroke="#d8d8d8" stroke-width="1" fill="none"></path></g></g><g><text style="font:12px sans-serif;white-space:pre;" x="63.5" y="253" stroke="none" fill="#707070" fill-opacity="1">$0</text></g><g><text style="font:12px sans-serif;white-space:pre;" x="91.7" y="253" stroke="none" fill="#707070" fill-opacity="1">$40k</text></g><g><text style="font:12px sans-serif;white-space:pre;" x="126.4" y="253" stroke="none" fill="#707070" fill-opacity="1">$80k</text></g><g><text style="font:12px sans-serif;white-space:pre;" x="157.6" y="253" stroke="none" fill="#707070" fill-opacity="1">$120k</text></g><g><text style="font:12px sans-serif;white-space:pre;" x="192.3" y="253" stroke="none" fill="#707070" fill-opacity="1">$160k</text></g><g><text style="font:12px sans-serif;white-space:pre;" x="227" y="253" stroke="none" fill="#707070" fill-opacity="1">$200k</text></g></g><g><g><text style="font:14px sans-serif;white-space:pre;" x="0" y="13" stroke="none" fill="#707070" fill-opacity="1">Top Organizations</text></g></g><g></g></g></svg>
      <div class="hover-info" ref="hover">
        <span class="hover-date">{{ hoverInfo.date }}</span>
        <span class="hover-amount">{{ hoverInfo.amount }}</span>
      </div>
    </div>
  </div>
  <footer class="footer">
    <span>View Report</span>
  </footer>

  <div class="options" v-if="optionsPanel">
    <header>
      <span>Options</span>
      <svg @click="closeOptions" class="x-icon" viewBox="0 0 14.01 13.91" id="close" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>close</title><path d="M8.45 6.95l5.2-5.2a1 1 0 0 0 .1-1.4 1 1 0 0 0-1.4-.1l-.1.1-5.2 5.2-5.2-5.2a1 1 0 0 0-1.4.1 1.05 1.05 0 0 0 0 1.3l5.2 5.2-5.3 5.2a1 1 0 0 0-.1 1.4 1 1 0 0 0 1.4.1l.1-.1 5.3-5.2 5.2 5.2a1 1 0 0 0 1.5-1.3l-.1-.1z" fill="#404040"></path></svg>
    </header>
    <div class="categories" v-if="optionsPanel == 'categories'">
      <div class="option-link">
        <span class="description">Date Range</span>
        <span class="link"><span class="link-label">Previous 12 Months</span> <svg class="chevron-icon" viewBox="0 0 7 18" id="next-arrow" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path fill="#404040" d="M1.792 3.18a.534.534 0 0 0-.798 0l-.796.859a.636.636 0 0 0 0 .858l3.844 4.086-3.876 4.121a.64.64 0 0 0 0 .858l.797.858c.22.238.577.238.799 0l5.073-5.408a.643.643 0 0 0 0-.86L1.792 3.18z"></path></svg></span>
      </div>
      <div class="option-link">
        <span class="description">Measure</span>
        <span class="link" @click="optionsPanel = 'selections'"><span class="link-label">{{ title }}</span> <svg class="chevron-icon" viewBox="0 0 7 18" id="next-arrow" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path fill="#404040" d="M1.792 3.18a.534.534 0 0 0-.798 0l-.796.859a.636.636 0 0 0 0 .858l3.844 4.086-3.876 4.121a.64.64 0 0 0 0 .858l.797.858c.22.238.577.238.799 0l5.073-5.408a.643.643 0 0 0 0-.86L1.792 3.18z"></path></svg></span>
      </div>
      <div class="option-link">
        <span class="description">Group By</span>
        <span class="link"><span class="link-label">Check Date</span> <svg class="chevron-icon" viewBox="0 0 7 18" id="next-arrow" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path fill="#404040" d="M1.792 3.18a.534.534 0 0 0-.798 0l-.796.859a.636.636 0 0 0 0 .858l3.844 4.086-3.876 4.121a.64.64 0 0 0 0 .858l.797.858c.22.238.577.238.799 0l5.073-5.408a.643.643 0 0 0 0-.86L1.792 3.18z"></path></svg></span>
      </div>
    </div>
    <div class="selections" v-if="optionsPanel == 'selections'">
      <div class="selection">Overtime Hours</div>
      <div class="selection" @click="makeSelection('overtimeAmount')" :data-selected="title === 'Overtime Amount'">Overtime Amount</div>
      <div class="selection" @click="makeSelection('regHours')" :data-selected="title === 'Regular Hours'">Regular Hours</div>
      <div class="selection">Regular Amount</div>
      <div class="selection">Labor Cost</div>
      <div class="selection">Earnings & Reimbursements</div>
      <div class="selection">ER Benefits Cost</div>
    </div>
  </div>

</div>
</template>

<script>
export default {
    name: "equal-pay-panel",
    props: {},
    data: function(){
        return {
          optionsPanel: false,
          currentCircleIndex: -1,
          startMonth: 0,
          chartKey: "payCategories",
          chartData: {
            months: ["2 West", "East", "101 Safety Consulting", "70000 Central Intake", "Cafeteria Plans", "Deduction", "Retirement", "Information", "Fringe Benefits","Nov", "Dec"],
            payCategories: {
              total: "19,964 hrs",
              title: "Pay Item Categories",
              legend: ["3k", "2k", "1k", "0"],
              amounts: ["$182,000.00","$72,129.98","$64,168.00","$49,400.00","$1,086.32","$803.40","$765.41","0","0","0","0"],
              amounts2: ["1,733","2,622","1,324","2,542","1,956","1,306","2,418","1,194","1,773","1,812"]
            }
          }
        }
        },
    methods: {

      closeOptions: function(){

        this.optionsPanel = false;

      },

      onCircleOver: function(e){
        let chartBox = this.$refs.container.querySelector('.chartSVG').getBoundingClientRect();
        let circleBox = e.target.getBoundingClientRect();

        console.log(chartBox, circleBox);
        let hoverEl = this.$refs.hover;
        this.currentCircleIndex = parseInt(e.target.dataset.index);

        this.$refs.hover.style.display = "block";


        hoverEl.style.top = 0.92 * ((((circleBox.y - chartBox.y) + circleBox.height )/ chartBox.height) * 100) +"%";
        hoverEl.style.left = 0.9 * ((((circleBox.x - chartBox.x) + circleBox.width )/ chartBox.width) * 100) +"%";

      },

      onCircleOut: function(){
        this.$refs.hover.style.display = "none";
      },

      showOptions: function(){
        this.optionsPanel = 'categories';
      },

      makeSelection: function(key){
        this.chartKey = key;
        this.closeOptions();
      }
    },
    computed: {

      total: function(){
        return this.chartData[this.chartKey].total;
      },

      title: function(){
        return this.chartData[this.chartKey].title;
      },

      hoverInfo: function(){

        if(this.currentCircleIndex >= 0){
          let month = this.chartData.months[this.currentCircleIndex];
          let amount = this.chartData[this.chartKey].amounts[this.currentCircleIndex];



          return {
            date: month,
            amount: amount
          }
        }

        return {
          date: "",
          month: ""
        }
      }
    }
}
</script>

<style scoped>


.equal-pay-panel {
  position: absolute;
  border: 1px solid #D0D0D0;
  border-radius: 5px;
  background-color: white;




}

.equal-pay-panel .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 1.2em;
  padding-bottom: 1.0em;
  border-bottom: 1px solid rgb(226,226,226);
  color: #444444;
  font-size: 1em;
}

.equal-pay-panel .details {
  padding: 1.3em 0;
  margin: 0 1.2em;
  padding-bottom: 0.7em;
  border-bottom: 1px solid rgb(226,226,226);
}

.details p {
  font-size: 0.875em;
  margin: 0;
  margin-bottom: 0.325em;
  color: #777777;
}

.details .blue-dot {
  display: inline-block;
  width: 0.7em;
  height: 0.7em;
  border-radius: 100%;
  background-color: #4b6caa;
  margin-right: 1em;
}

.details p.dates {
  margin-bottom: 0.25em;
}

.details p.amount {
  margin-bottom: 0;
  font-size: 1.5em;
  color: #444444;
}

.details p.legend {
  margin-bottom: 0.20em;
}

.chart-container {
  position: relative;
  padding: 1em;
  padding-bottom: 0.25em;
  border-bottom: 1px solid rgb(226,226,226);
}

.chart-container circle:hover {
  fill: #4b6caa;
}


.footer {
  padding: 0.375em 1.2em;
  padding-top: 1.3em;
  padding-bottom: 1.2em;
  text-align: center;
  font-size: 0.875em;
  color: #4b6caa;
}

.hover-info {
  padding: 0.5em;
  background-color: #4b6caa;
  color: white;
  position: absolute;
  text-align: center;
  margin: 0.4em 1.2em;
  display: none;
}

.hover-date {
  display: block;
  white-space: nowrap;

}

.hover-amount {
  display: block;
  white-space: nowrap;


}

.editIcon {
  height: 1.3em;
  width: 0.25em;
  display: inline-block;

}

.options {
  position: absolute;
  top: 0;
  left: 100%;
  margin-left: -2.25em;
  margin-top: -0.1em;
  background: white;
  width: 19.75em;
  box-sizing: border-box;
  padding: 0.7em 0.9em;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0,0,0,0.12);
}

.options header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.1em;
}

.options header .x-icon {
  width: 1em;
  height: 1em;
  display: inline-block;
}

.chevron-icon {
  width: 0.5em;
}

.options .option-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.0em;
}

.options .option-link:last-child {
  padding-bottom: 1.2em;
}

.options .option-link .description {
  font-size: 0.9em;
}

.options .option-link .link {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.options .option-link .link:hover {
  text-decoration: none;
}

.options .option-link .link-label {
  color: #0369b1;
  font-size: 0.9em;
  margin-right: 0.75em;
}

.selections {
  margin-top: 0.9em;
}

.selection {
  margin: 0 -0.9em;
  padding: 0.9em;
  cursor: pointer;
}

.selection:hover {
 background-color: rgba(0,0,0,.03);
}

.selection[data-selected='true'] {
   color: #0369b1;
   background-color: #e5f0f7;
}

.selection[data-selected='true']:hover {
  background-color: #e5f0f7;
}

</style>
